<template>
  <div>
    <v-breadcrumbs
      :items="breadcrumbs"
      class="grey lighten-2 white--text"
    ></v-breadcrumbs>
    <div>
      <div class="pa-4">
        <div class="d-flex justify-space-between align-center mb-4">
          <v-btn
            small
            depressed
            color="fmq_gray"
            dark
            outlined
            to="/especialidades"
          >
            <v-icon small> mdi-arrow-left </v-icon>Voltar</v-btn
          >
        </div>
        <EspecialidadeFormulario @send="criar" />
      </div>
    </div>
    <AlertSuccess
      :dialog="success"
      dialogMessage="Especialidade criada com sucesso"
      @close="goToEspecialidade"
    />
    <AlertError :alertError="error" :messageError="messageError" />
  </div>
</template>

<script>
import { criarEspecialidade } from "@/services/especialidades";
import EspecialidadeFormulario from "@/components/especialidades/EspecialidadeFormulario.vue";
export default {
  name: "EspecialidadesCriar",
  components: { EspecialidadeFormulario },
  data: () => ({
    breadcrumbs: [
      {
        text: "Especialidades",
        disabled: false,
        to: "/especialidades",
      },
      {
        text: "Criar Especialidade",
        disabled: true,
        to: "",
      },
    ],
    error: false,
    success: false,
    loadingBtn: false,
    messageError: null,
  }),
    beforeCreate() {
    if(this.$store.state.user.data.tipo === "Representante") {
      this.$router.push({path: '/'})
    }
  },
  methods: {
    async criar(event) {
      this.error = false;
      this.sucess = false;
      this.loadingBtn = true;
      try {
        await criarEspecialidade(event).then(() => {
          this.success = true;
        });
        this.loadingBtn = false;
      } catch (e) {
        this.loadingBtn = false;
        this.error = true;
        this.messageError = e.response.data.message;
      }
    },
    goToEspecialidade() {
      this.sucess = false;
      this.$router.push({ name: "Especialidades" });
    },
  },
};
</script>

<style></style>
